import axios from '@/util/request'

// 选择支援模版添加到草稿志愿
export const addDraftPlanFromTemplate = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/addDraftPlanFromTemplate',
        method: 'post',
        data,
    })
}

// /com/had-login/aspiration/aspiration-preliminary/cancelFormal
// 取消设为志愿方案
export const cancelFormal = (params) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/cancelFormal',
        method: 'get',
        params,
    })
}

// /com/had-login/aspiration/aspiration-preliminary/copy
// 复制预案
export const copyDraft = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/copy',
        method: 'post',
        data,
    })
}

// /com/had-login/aspiration/aspiration-preliminary/deleteDraft
// 删除志愿预案
export const deleteDraft = (params) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/deleteDraft',
        method: 'get',
        params
    })
}

// /com/had-login/aspiration/aspiration-preliminary/getDraftList
// 预案列表查询
export const getDraftList = (params) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/getDraftList',
        method: 'get',
        params
    })
}

// /com/had-login/aspiration/aspiration-preliminary/setFormal
// 设为志愿方案
export const setFormal = (params) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/setFormal',
        method: 'get',
        params
    })
}

// 修改预案方案名称
export const updateDraftPlanName = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/updateDraftPlanName',
        method: 'post',
        data,
    })
}

// 预案志愿详情
// /com/had-login/aspiration/aspiration-preliminary/getDraftPlanDetail
export const getDraftPlanDetail = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/getDraftPlanDetail',
        method: 'post',
        data
    })
}

// /com/had-login/aspiration/aspiration-preliminary/previewAdmit
export const previewAdmitDraft = (params) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/previewAdmit',
        method: 'get',
        params
    })
}

// /com/had-login/aspiration/aspiration-preliminary/save
// 保存志愿预案
export const savedraft = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/save',
        method: 'post',
        data
    })
}

// /com/had-login/aspiration/aspiration-preliminary/selectCollegeList
// 选择院校列表
export const selectCollegeList = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/selectRecommendCollegeList',
        method: 'post',
        data
    })
}

// /com/had-login/aspiration/aspiration-preliminary/selectCollegeOptionsList
// 选择专业组志愿列表(含院校
export const selectCollegeOptionsList = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/selectCollegeOptionsList',
        method: 'post',
        data,
    })
}

// POST /com/had-login/aspiration/aspiration-preliminary/selectCollegeSpecialtyList
export const selectCollegeSpecialtyList = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/selectCollegeSpecialtyList',
        method: 'post',
        data,
    })
}

// /com/had-login/aspiration/aspiration-preliminary/selectEqualScore
// 查询等位分成绩
export const selectEqualScore = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/selectEqualScore',
        method: 'post',
        data
    })
}

// POST /com/had-login/aspiration/aspiration-preliminary/selectSpecialtyOptionsList
// 选择专业志愿列表(含院校+专业组)
export const selectSpecialtyOptionsList = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/selectSpecialtyOptionsList',
        method: 'post',
        data,
    })
}

// POST /com/had-login/aspiration/aspiration-preliminary/selectSpecialtyOptionsListV2
// 选择专业志愿列表(含院校+专业组)
export const selectSpecialtyOptionsListV2 = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/selectSpecialtyOptionsListV2',
        method: 'post',
        data,
    })
}

// /com/had-login/aspiration/aspiration-preliminary/systemAssess
// 系统评审
export const systemAssess = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/systemAssess',
        method: 'post',
        data
    })
}

// POST /com/had-login/aspiration/aspiration-preliminary/updateDraftPlanSort
// 草稿排序
export const updateDraftPlanSort = (data) => {
    return axios({
        url: '/com/had-login/aspiration/aspiration-preliminary/updateDraftPlanSort',
        method: 'post',
        data,
    })
}